/* eslint-disable */
import { produce } from "immer";
import {
  GUIDANCE_EXPLORER_FETCH_START,
  GUIDANCE_EXPLORER_SUCCESS,
  GUIDANCE_EXPLORER_FAILURE,
} from "../actions/types";

const guidanceExplorer = (
  state = {
    fetching: false,
    data: [],
    error: null,
  },
  action,
) => {
  switch (action.type) {
    case GUIDANCE_EXPLORER_FETCH_START:
      return produce(state, (draft) => {
        draft.fetching = true;
      });
    case GUIDANCE_EXPLORER_SUCCESS:
      return produce(state, (draft) => {
        draft.fetching = true;
        draft.data = action.data;
        draft.fetching = false;
      });
    case GUIDANCE_EXPLORER_FAILURE:
      return produce(state, (draft) => {
        draft.fetching = false;
        draft.error = action.error;
      });
    default:
      return state;
  }
};

export default guidanceExplorer;
